import { useApiQuery } from '@BUP/hooks/useApiQuery'

/**
 * Distinct grade tags found on the current organization/term's courses (e.g. ['nivel:5',
 * 'nivel:8']) - lets the counselor pick a real, valid grade when opening a period instead of
 * typing one freehand. The backend derives these from each course's `nivel:N` tag (verified
 * against production - `grade:X` is essentially unique per course there, not shared across a
 * grade's sections, so it can't be used for this).
 */
export const useGetAvailableGrades = () => {
  const query = useApiQuery(
    ['courseAssignmentAvailableGrades'],
    'schools',
    client => client.get('/current-organization/course-assignment/grades'),
    {},
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    grades: query.data?.grades ?? [],
    error: query.error
  }
}
